import React from "react";
import { Card, CardHeader, CardBody, Container } from "reactstrap";
import SimpleHeader from "@/components/Headers/SimpleHeader";
import TableWrapper from "@/utils/TableWrapper";
import type { TableWrapperProps } from "@/utils/TableWrapper";

export type DisplayClientsViewProps = {
  clients: unknown[];
  columns: TableWrapperProps<unknown>["columns"];
  alert: React.ReactNode;
  /** react-toastify's ToastContainer, handed in by the container. */
  ToastContainer: React.ElementType;
};

const DisplayClientsView = ({
  clients,
  columns,
  alert,
  ToastContainer,
}: DisplayClientsViewProps) => {
  return (
    <>
      <div className="rna-wrapper">
        <ToastContainer />
      </div>
      {alert}
      <SimpleHeader name="Display Clients" parentName="Clients" />
      <Container className="mt--6" fluid>
        <Card>
          <CardHeader>
            <h3 className="mb-0">All Clients</h3>
          </CardHeader>
          <CardBody>
            <TableWrapper data={clients} columns={columns} />
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default DisplayClientsView;
